import React from 'react';
import { compose, withStateHandlers } from "recompose";
import { withGoogleMap, withScriptjs, GoogleMap, Marker } from 'react-google-maps';
import LocationText from "../elements/LocationText";

// To disabled fullscreen preview icon
const defaultMapOptions = {
    fullscreenControl: true,
};
let Map = compose(
    withStateHandlers(() => ({
        isMarkerShown: true,
        isClicked:false,
        markPosition: null,
        infoLat:null,
        infoLng:null,
      }), {
        onMapClick: ({ isMarkerShown }) => (e) => ({
            markPosition: e.latLng,
            isClicked:true,
            isMarkerShown:true,
            infoLat:e.latLng.lat(),
            infoLng:e.latLng.lng(),
        })
        
    }),
    withScriptjs,
    withGoogleMap
)
    (props =>
        <React.Fragment>
            <GoogleMap
                defaultZoom={props.defaultZoom}
                // defaultCenter={{ lat: 24.176869443745133, lng: 46.068425139287385 }}
                defaultCenter={new google.maps.LatLng(props.curlocation.lat, props.curlocation.lng)}
                onClick={props.onMapClick}
                defaultOptions={defaultMapOptions}
            >
                {/* {props.isMarkerShown && <Marker position={props.curlocation} />} */}
                {props.isClicked?(
                    <Marker position={props.markPosition} />
                ):(
                    <Marker position={props.curlocation} />
                )}

            </GoogleMap>
            {props.isClicked?(
                <LocationText
                    lat={props.infoLat}
                    lng={props.infoLng}
                    action={props.isAction}               
                />
            ):(
                // <LocationText>{props.defaultText}</LocationText>
                <LocationText
                    lat={props.curlocation.lat}
                    lng={props.curlocation.lng}
                    action={props.isAction}               
                />                
            )}
            
        </React.Fragment>
    )

export default class MapContainer extends React.Component {
    constructor(props) {
        super(props);
    }
    
    //SEC: AIzaSyDOsfTA_2CBvCcOxQwpLYrlm1UBbBiLgx0
    //Test: AIzaSyA1y8bMI9HUR3lZvjAf6doh4vcEaVz6hGM
    render() {
        // let defaultText = this.props.language && this.props.language==='ar'?'الرجاء تحديد الموقع':'Please select location';
        let defaultText = this.props.defaultText;
        // pos=this.props.curlocation;
        // console.log(this.props.currentLocation);
        return (            
            <div style={{ height: '100%' }}>
                <Map
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBDafEEdB_LeI6DedYoTy2BU_GRlmknRNo"
                    loadingElement={<div style={{ height: `calc(100% - 50px)` }} />}
                    containerElement={<div style={{ height: `calc(100% - 50px)` }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                    isAction={this.props.action}
                    curlocation={this.props.currentLocation}
                    defaultText={defaultText}
                    defaultZoom={this.props.defaultZoom}
                />
            </div>
        )
    }
}